import "@claviska/jquery-minicolors"
import "@claviska/jquery-minicolors/jquery.minicolors.css"

$(function() {
  $(".mini-color").minicolors({
    letterCase: "uppercase",
    theme: "bootstrap"
  })
})
